import { render } from "./MainMultiple.vue?vue&type=template&id=31468dad&scoped=true&lang=pug"
import script from "./MainMultiple.vue?vue&type=script&setup=true&lang=js"
export * from "./MainMultiple.vue?vue&type=script&setup=true&lang=js"

import "./MainMultiple.vue?vue&type=style&index=0&id=31468dad&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31468dad"]])

export default __exports__